var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"avatar",class:'avatar--' + _vm.size},[(_vm.runner && _vm.runner.avatar)?_c('img',{staticClass:"avatar__image",attrs:{"src":_vm.runner.avatar,"alt":_vm.$t('User avatar')}}):_c('img',{staticClass:"avatar__image",attrs:{"src":_vm.randomAvatar,"alt":_vm.$t('User avatar')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }